/**
 * Slider Component
 *
 * @file slider.js
 */

import $ from 'jquery';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Thumbs, Controller, EffectFade, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Thumbs, Controller, EffectFade, Autoplay]);

import 'swiper/swiper-bundle.css';
import 'swiper/swiper-bundle.js';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    if (window.matchMedia('(min-width: 767px)').matches) {

      $(".intro-nav-list li").on("click", function(){
        $(".ibg-init-video").removeClass("active");
        $("#slider-video-"+$(this).index()+"").addClass("active");
        document.querySelectorAll('.ibg-init-video').forEach(function(el) {
          console.log(el.querySelector('video').pause());
          el.querySelector('video').pause();
          el.querySelector('video').currentTime = 0;
        });
        if($("#slider-video-"+$(this).index()+"").is(":visible")){
          document.getElementById("slider-video-"+ $(this).index() +"").querySelector('video').play();
          if($(".intro-nav-list li").eq(0).hasClass("active")){
            document.querySelectorAll('.ibg-init-video').forEach(function(el) {
              el.querySelector('video').pause();
            });
            document.getElementById("slider-video-0").classList.add("active");
            document.getElementById("slider-video-0").querySelector('video').play();
          }
        }
      });
    }
    var swiper = new Swiper(".mySwiper", {
      spaceBetween: 0,
      slidesPerView: 6,
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          slidesPerView: 5,
          centeredSlides: true,
          loop:true
        },
        1280: {
          slidesPerView: 6,
          centeredSlides: false,
        },
      },
    });
    var swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 0,
      effect: 'fade',
      speed: 1000,
      // thumbs: {
      //   swiper: swiper,
      // }
  
      on: {
        init: function() {
          if (window.matchMedia('(max-width: 766px)').matches) {
            var activeIndexInit = this.realIndex;
            var activeSlideInit = document.getElementsByClassName('swiper-slide')[activeIndexInit];
            var activeSlideVideoInit = activeSlideInit.getElementsByTagName('video')[0];
            activeSlideVideoInit.play();
          }
        },
        transitionStart: function(){
          
          if (window.matchMedia('(max-width: 766px)').matches) {
            var videos = document.querySelectorAll('video');

            Array.prototype.forEach.call(videos, function(video){
              video.pause();
            });
          }
        },
        transitionEnd: function(){
          if (window.matchMedia('(max-width: 766px)').matches) {
            var activeIndexS = this.realIndex;
            var activeSlideS = document.getElementsByClassName('swiper-slide')[activeIndexS];
            var activeSlideVideo = activeSlideS.getElementsByTagName('video')[0];
            activeSlideVideo.play();
          }
        
        },
      
      }
    });

    $(".th-slide").hover(function(){
      $(".thumb-hover").css("margin-left", $(this).offset().left);
    }, function(){
      $(".thumb-hover").css("margin-left", $(".swiper-slide-thumb-active").offset().left);
    });
    var divs = $('.home-slider-spacing');
      $(window).on('scroll', function() {
      var st = $(this).scrollTop();
      divs.css({ 'opacity' : -(1 - st/250) });
      divs.css({ 'z-index' : -(1 - st) });
    });
  };

  const newsSlider = () => {
    const swiperNews = new Swiper('.media-carousel', {
      spaceBetween: 0,
      initialSlide: 0,
      slidesPerView: 4,
      loop:true,
      navigation: {
        nextEl: '.media-right',
        prevEl: '.media-left',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
        },
        680: {
          slidesPerView: 2.5,
        },
        992: {
          slidesPerView: 3.5,
        },
        1280: {
          slidesPerView: 4,
        },
        1480: {
          slidesPerView: 4,
        },
      },
    });
    $(".media-tabs .left a").on("click", function(){
      console.log($(this).attr("href"));
      $(".media-tabs .left a").removeClass("active");
      $(this).addClass("active");
      $(".media-carousel-tab").removeClass("active");
      $($(this).attr("href")).addClass("active");
      const swiperNews = new Swiper('.media-carousel', {
        spaceBetween: 0,
        initialSlide: 0,
        slidesPerView: 5,
        loop:true,
        navigation: {
          nextEl: '.media-right',
          prevEl: '.media-left',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            centeredSlides: false,
          },
          680: {
            slidesPerView: 2.5,
          },
          992: {
            slidesPerView: 3.5,
          },
          1280: {
            slidesPerView: 4,
          },
          1480: {
            slidesPerView: 4,
          },
        },
      });
      return false;
    });
  }

  const globalSlider = () => {
    const globalNews = new Swiper('.global-carousel', {
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: '.global-right',
        prevEl: '.global-left',
      },
    });
  }


  const homeBrandSlider = () => {
    const homeBrandSlider = new Swiper('.home-brand-carousel', {
      spaceBetween: 0,
      slidesPerView: 5,
      navigation: {
        nextEl: '.brand-next-arrow',
        prevEl: '.brand-prev-arrow',
      },
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        320: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 3,
        },
        1380: {
          slidesPerView: 4,
        },
        1600: {
          slidesPerView: 5,
        },
      },
    });
  }

  // const companySlider = () => {
  //   const companySliderThumb = new Swiper('.company-left-carousel', {
  //     spaceBetween: 0,
  //     slidesPerView: 1,
  //     watchOverflow: true,
  //     watchSlidesVisibility: true,
  //     watchSlidesProgress: true,
  //     direction: 'vertical',
  //     allowTouchMove: false,
  //   });
  //   const companySlider = new Swiper('.company-right-carousel', {
  //     spaceBetween: 35,
  //     slidesPerView: 3,
  //     centeredSlides: true,
  //     direction: 'vertical',
  //     mousewheel: true,
  //     watchOverflow: true,
  //     watchSlidesVisibility: true,
  //     watchSlidesProgress: true,
  //     preventInteractionOnTransition: true,
  //     thumbs: {
  //       swiper: companySliderThumb
  //     },
  //     breakpoints: {
  //       0: {
  //         slidesPerView: 1,
  //         direction: 'horizontal',
  //       },
  //       680: {
  //         slidesPerView: 1,
  //         direction: 'horizontal',
  //       },
  //       760: {
  //         slidesPerView: 3,
  //         direction: 'vertical',
  //       },
  //     },
  //   });
  // }

  const activityCarousel = () => {
    const activityCarousel = new Swiper('.activity-carousel', {
      spaceBetween: 20,
      slidesPerView: 4,
      loop:true,
      navigation: {
        nextEl: '.activity-right',
        prevEl: '.activity-left',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        680: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
        1380: {
          slidesPerView: 4,
        },
      },
    });
  }

  const managementCarousel = () => {
    const managementCarousel = new Swiper('.management-carousel', {
      spaceBetween: 20,
      slidesPerView: 4,
      navigation: {
        nextEl: '.activity-right',
        prevEl: '.activity-left',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
        },
        680: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1380: {
          slidesPerView: 4,
        },
      },
    });
    $(".management-staff .swiper-slide").each(function(){
      var managementDesc = $(this).find(".desc");
      managementDesc.css("margin-bottom", -managementDesc.innerHeight());
    }).hover(function(){
      var managementDesc = $(this).find(".desc");
      managementDesc.css("margin-bottom", "0px");
    }, function(){
      var managementDesc = $(this).find(".desc");
      managementDesc.css("margin-bottom", -managementDesc.innerHeight());
    });
  }

  const tripleSlider = () => {
    const globalNews = new Swiper('.triple-carousel', {
      spaceBetween: 45,
      slidesPerView: 3,
      breakpoints: {
        0: {
          spaceBetween: 15,
          slidesPerView: 1.2,
        },
        680: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
        },
        1280: {
          spaceBetween: 45,
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: '.arr.next-arrow',
        prevEl: '.arr.prev-arrow',
      },
    });
  }

  const init = () => {
    fullSlider();
    newsSlider();
    homeBrandSlider();
    globalSlider();
    // companySlider();
    activityCarousel();
    managementCarousel();
    tripleSlider();
  };

  return {
    init,
  };
})();

export default slider;
